import { canonicalUrl } from "@/config/canonical";
import { useSeoCopy } from "@/config/seo";
import { HeroSection } from "@/containers/HeroSection";
import TacticsBanner from "@/features/Tactics/TacticsBanner";

const TacticHeroSection = () => {
  const tactics = useSeoCopy("tactics");
  return (
    <HeroSection
      helmetTitle={tactics.title}
      helmetDescription={tactics.description}
      helmetCanonicalLink={canonicalUrl("/tactics")}
    >
      <TacticsBanner />
    </HeroSection>
  );
};

export default TacticHeroSection;
